// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const gatherHeader = "GatherHeader__gatherHeader__VpF5K";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const progress = "GatherHeader__progress__jdATz";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const subtitleWrapper = "GatherHeader__subtitleWrapper__38vY1";
export const title = "GatherHeader__title__HSgLR";